import Vue from 'vue';
import store from '@/store'
Vue.filter('showTitle', function (val, key) {
    try {
        return val[store.state.lang];
    } catch (e) {
        return val
    }
})